import {useQuery} from '@tanstack/react-query';
import {staticQueryDefaults} from '~/lib/queryClient';
import {fetchImpersonatableUsers} from '~/modules/RillAnalytics/api';
import {fetchAgencies, fetchAllSellers} from '~/modules/Clients/api';
import {fetchUser, fetchUsers} from '~/modules/Users/api';

export const IMPERSONATABLE_USERS_QUERY_KEY = ['rill-impersonatable-users'] as const;
export const useImpersonatableUsersQuery = () =>
    useQuery({
        queryKey: IMPERSONATABLE_USERS_QUERY_KEY,
        queryFn: fetchImpersonatableUsers,
        ...staticQueryDefaults,
    });

export const RILL_ALL_USERS_QUERY_KEY = ['rill-all-users'] as const;
export const useAllUsersQuery = () =>
    useQuery({
        queryKey: RILL_ALL_USERS_QUERY_KEY,
        queryFn: fetchUsers,
        ...staticQueryDefaults,
    });

export const RILL_ALL_SELLERS_QUERY_KEY = ['rill-all-sellers'] as const;
export const useAllSellersQuery = () =>
    useQuery({
        queryKey: RILL_ALL_SELLERS_QUERY_KEY,
        queryFn: fetchAllSellers,
        ...staticQueryDefaults,
    });

export const useRillUserQuery = (userId: number | null) =>
    useQuery({
        queryKey: ['rill-user', userId],
        queryFn: () => fetchUser(String(userId)),
        enabled: userId != null,
        ...staticQueryDefaults,
    });

export const RILL_ALL_AGENCIES_QUERY_KEY = ['rill-all-agencies'] as const;
export const useAllAgenciesQuery = () =>
    useQuery({
        queryKey: RILL_ALL_AGENCIES_QUERY_KEY,
        queryFn: () => fetchAgencies(),
        ...staticQueryDefaults,
    });
